/**
 * Why a client failed to identify its analytics subject — one closed list
 * shared by every client so the identification monitors and charts read the
 * same vocabulary. Never carries a token, email or other personal value.
 */
export const IDENTIFY_FAILURE_REASONS = [
  'http_401',
  'http_403',
  'http_4xx',
  'http_5xx',
  'network',
  'invalid_response',
  'analytics_not_ready',
  'provider_error',
  'superseded',
] as const;
export type IdentifyFailureReason = (typeof IDENTIFY_FAILURE_REASONS)[number];

/** The reason for an HTTP answer that carried no usable context; `network` when there was none. */
export function identifyFailureReasonForStatus(status: number | undefined): IdentifyFailureReason {
  if (status === undefined) return 'network';
  if (status === 401) return 'http_401';
  if (status === 403) return 'http_403';
  if (status >= 500) return 'http_5xx';
  if (status >= 400) return 'http_4xx';
  return 'invalid_response';
}
